import { Box } from "@mui/material";
import FieldTypeForm from "../components/forms/fieldTypeForm.component";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateFieldTypeStart } from "../store/features/fieldType/fieldTypeSlice";

const UpdateFieldTypePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const fieldsType = useSelector((state) => state.fieldsType?.data?.data);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector((state) => state.fieldType);

  const fieldType = fieldsType?.find((ft) => String(ft.id) === String(id));

  const onSubmit = (data) => {
    dispatch(
      updateFieldTypeStart({ data, accessToken: accessToken, fieldTypeId: id })
    );
  };
  return (
    <Box width="100%">
      <FieldTypeForm
        mode="update"
        defaultValues={fieldType}
        onSubmit={onSubmit}
        accessToken={accessToken}
        fieldType={fieldType}
        error={error}
        isLoading={isLoading}
        success={success}
      />
    </Box>
  );
};

export default UpdateFieldTypePage;
